import {BaseComponentLifecycleEventHandler} from "../../../infrastructure/handlers/base-component-lifecycle-event-handler";
import {ScoresListHeaderModuleController} from "../scores-list-header-module.controller";
import {ScoresListHeaderModuleState} from "../models/scores-list-header-module.state";

export class ScoresListHeaderModuleStatePopulationHandler extends BaseComponentLifecycleEventHandler {
  controller: ScoresListHeaderModuleController;
  state: ScoresListHeaderModuleState;

  onInitialized(controller: ScoresListHeaderModuleController) {
    super.onInitialized(controller);

    this.state._initializeDays();

    this.state.isLive = controller.props.isLive;
    this.state.startDate = controller.props.date;
    this.state.endDate = controller.props.endDate;
    this.state.linkType = controller.props.linkType;
  }

  onDidUpdate(prevProps, nextProps) {
    super.onDidUpdate(prevProps, nextProps);

    this.state.isLive = nextProps.isLive;
    this.state.startDate = nextProps.date;
    this.state.endDate = nextProps.endDate;
    this.state.linkType = nextProps.linkType;

    const isSportTypeChanged: Boolean = prevProps.nextLinkModel?.params.sportName !== nextProps.nextLinkModel?.params.sportName;

    if(isSportTypeChanged) {
      this.state._days = this.state.createMobileDaterDates(nextProps.nextLinkModel.params.sportName)
    }
  }
}
